import { render, staticRenderFns } from "./SectionDefinition.vue?vue&type=template&id=cbe66836&scoped=true&"
import script from "./SectionDefinition.vue?vue&type=script&lang=js&"
export * from "./SectionDefinition.vue?vue&type=script&lang=js&"
import style0 from "./SectionDefinition.vue?vue&type=style&index=0&id=cbe66836&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe66836",
  null
  
)

export default component.exports